/* eslint-disable import/prefer-default-export */

export { appConfig as config } from 'roc-package-web-app-react/app/shared/universal-config';



/** WEBPACK FOOTER **
 ** ./src/config.js
 **/